<template lang="pug">
  .coach-detail-review-summary
    span {{ formatReviewRateAverage }}
    rating-star(:rating="coach.reviewRateAverage" :size="28")
    span {{ `${numberFormat(coach.reviewCount)}件の評価` }}
</template>

<style lang="scss" scoped>
.coach-detail-review-summary {
  display: flex;
  align-items: center;

  span:first-child {
    @extend %stepbadge-number-text;
  }
  .rating-star {
    margin: 0 16px;
  }
  span:last-child {
    @extend %label-text;
  }
}
</style>

<script>
import RatingStar from '@/components/atoms/RatingStar'
import Formatter from '@/components/mixins/Formatter'

export default {
  components: {
    RatingStar,
  },
  mixins: [Formatter],
  props: {
    coach: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formatReviewRateAverage() {
      return Math.floor(this.coach.reviewRateAverage * 100) / 100
    },
  },
  methods: {
    reviewerName(monthOfReview) {
      return `${this.dateFormat(monthOfReview, 'Y年M月')}受講生`
    },
  },
}
</script>
